/* eslint-disable react/require-default-props */
import React from 'react';
function Accordion({ title, children }) {
    return (React.createElement("details", { className: "qmb-accordion" },
        React.createElement("summary", null,
            title,
            React.createElement("span", { className: "accordion__preview" })),
        children));
}
export default Accordion;
